import React from 'react';
import { UserContextCreator } from '../actions/ContextCreators';

// This consumer passes down the main MGP LoadState (OAuth/orchis-token) data once authentication is completed
const connectWithUserStore = Container => props => (
  <UserContextCreator.Consumer>
    {context => <Container {...context} {...props} />}
  </UserContextCreator.Consumer>
);

export default connectWithUserStore;
